import React, { useContext } from 'react';
import FORM_HEADERS from '../../../enums/formHeaders';
import { OrderReviewContext } from '../OrderReviewContext';
import { CommercialNarratives } from './CommercialNarratives';
import { CoreLogicLevel1 } from './CoreLogicLevel1';
import { CoreLogicLevel1NoCalc } from './CoreLogicLevel1NoCalc';
import { CoreLogicLevel2 } from './CoreLogicLevel2';
import { DefaultFormHeader } from './DefaultFormHeader';
import { E2VLevel1 } from './E2VLevel1';
import { E2VLevel1NoCalc } from './E2VLevel1NoCalc';

import { E2VLevel2 } from './E2VLevel2';
import { ISO360Level1 } from './ISO360Level1';

export const FormHeader = props => {
  const { state } = useContext(OrderReviewContext);

  switch (state.formHeaders[state.activeFormHeaderIndex].formHeaderId) {
    case FORM_HEADERS.E2V_LEVEL_1:
    case FORM_HEADERS.E2V_LEVEL_1_OTHER_STRUCTURES_REPLACEMENT_COST:
    case FORM_HEADERS.MOBILE_HOME:
    case FORM_HEADERS.MOBILE_HOME1:
      return <E2VLevel1 {...props} />;
    case FORM_HEADERS.E2V_L1_NO_CALC:
      return <E2VLevel1NoCalc {...props} />;
    case FORM_HEADERS.E2V_LEVEL_2:
      return <E2VLevel2 {...props} />;
    case FORM_HEADERS.ISO_360_LEVEL_1:
      return <ISO360Level1 {...props} />;
    case FORM_HEADERS.CORE_LOGIC_LEVEL_1:
      return <CoreLogicLevel1 {...props} />;
    case FORM_HEADERS.CORE_LOGIC_LEVEL_1_NO_CALC:
      return <CoreLogicLevel1NoCalc {...props} />;
    case FORM_HEADERS.CORE_LOGIC_LEVEL_2:
      return <CoreLogicLevel2 {...props} />;
    case FORM_HEADERS.COMMERCIAL_NARRATIVES:
    case FORM_HEADERS.COMMERCIAL_NARRATIVES_OB:
      return <CommercialNarratives {...props} />;
    default:
      return <DefaultFormHeader {...props} />;
  }
};
